import { render, staticRenderFns } from "./cModalViewDispatch.vue?vue&type=template&id=3fbf9b3e&scoped=true"
import script from "./cModalViewDispatch.vue?vue&type=script&lang=js"
export * from "./cModalViewDispatch.vue?vue&type=script&lang=js"
import style0 from "./cModalViewDispatch.vue?vue&type=style&index=0&id=3fbf9b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf9b3e",
  null
  
)

export default component.exports